var _ellipse, _ellipse2, _ellipse3, _path, _g, _path2, _path3, _g2, _path4, _path5, _g3, _path6, _g4, _path7, _path8, _g5, _path9, _path10, _g6, _path11, _g7, _path12, _g8, _path13, _path14, _g9, _path15, _path16, _path17, _path18, _g10, _path19, _g11, _path20, _g12, _path21, _g13, _path22, _g14, _path23, _g15, _path24, _g16, _g17, _g18, _g19, _g20, _path25, _path26, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCognition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 196,
    viewBox: "0 0 195 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.4021,
    cy: 97.5772,
    rx: 96.9021,
    ry: 97.0772,
    stroke: "#04D9B5",
    strokeOpacity: 0.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.402,
    cy: 97.5772,
    rx: 77.2977,
    ry: 77.4374,
    stroke: "#04D9B5",
    strokeOpacity: 0.4
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.4021,
    cy: 97.5773,
    rx: 57.7293,
    ry: 57.8336,
    stroke: "#04D9B5",
    strokeOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.7239 80.1902C59.7239 80.1902 47.6493 114.127 48.0666 114.187C48.4838 114.246 80.0192 108.346 80.0192 108.346L59.7239 80.1902Z",
    fill: "url(#paint0_linear_14804_48825)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_14804_48825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.6022 96.129L79.9724 108.415L59.4688 80.2369L62.8589 80.3679L97.6022 96.129Z",
    fill: "#D48DD6",
    fillOpacity: 0.02
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6022 96.129L79.9724 108.415L59.4688 80.2369L62.8589 80.3679L97.6022 96.129Z",
    fill: "url(#paint1_linear_14804_48825)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6022 96.129L79.9724 108.415L59.4688 80.2369L62.8589 80.3679L97.6022 96.129Z",
    fill: "url(#paint2_linear_14804_48825)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter2_i_14804_48825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9312 114.272L29.3319 108.093L56.6792 81.003L59.4688 80.237L47.9312 114.272Z",
    fill: "#C56694",
    fillOpacity: 0.02
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9312 114.272L29.3319 108.093L56.6792 81.003L59.4688 80.237L47.9312 114.272Z",
    fill: "url(#paint3_linear_14804_48825)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M47.9312 114.272L29.3319 108.093L56.6792 81.003L59.4688 80.237L47.9312 114.272Z",
    fill: "url(#paint4_linear_14804_48825)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter3_i_14804_48825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.0299 108.405L68.9408 128.046L64.5172 128.854L48.0708 114.246L80.0299 108.405Z",
    fill: "#D48DD6",
    fillOpacity: 0.02
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0299 108.405L68.9408 128.046L64.5172 128.854L48.0708 114.246L80.0299 108.405Z",
    fill: "url(#paint5_linear_14804_48825)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter4_i_14804_48825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.6476 96.3772L87.4881 116.516L69.2966 127.981L80.3743 108.691L97.6476 96.3772Z",
    fill: "#D48DD6",
    fillOpacity: 0.02
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6476 96.3772L87.4881 116.516L69.2966 127.981L80.3743 108.691L97.6476 96.3772Z",
    fill: "url(#paint6_linear_14804_48825)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6476 96.3772L87.4881 116.516L69.2966 127.981L80.3743 108.691L97.6476 96.3772Z",
    fill: "url(#paint7_linear_14804_48825)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter5_i_14804_48825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4683 108.839L48.8232 124.617L65.0353 128.76L48.466 114.857L29.4683 108.839Z",
    fill: "#C56694",
    fillOpacity: 0.02
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M29.4683 108.839L48.8232 124.617L65.0353 128.76L48.466 114.857L29.4683 108.839Z",
    fill: "url(#paint8_linear_14804_48825)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4683 108.839L48.8232 124.617L65.0353 128.76L48.466 114.857L29.4683 108.839Z",
    fill: "url(#paint9_linear_14804_48825)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_14804_48825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.563 81.7713L122.365 123.354L157.114 123.27L136.563 81.7713Z",
    fill: "#5EFFFF",
    fillOpacity: 0.02
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M136.563 81.7713L122.365 123.354L157.114 123.27L136.563 81.7713Z",
    fill: "url(#paint10_linear_14804_48825)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter8_i_14804_48825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.162 123.301L101.784 109.333L136.287 81.7L122.162 123.301Z",
    fill: "#D48DD6",
    fillOpacity: 0.02
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M122.162 123.301L101.784 109.333L136.287 81.7L122.162 123.301Z",
    fill: "url(#paint11_linear_14804_48825)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter9_i_14804_48825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.213 122.888L151.756 131.303L126.383 133.863L122.451 123.022L157.213 122.888Z",
    fill: "#C56694",
    fillOpacity: 0.02
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M157.213 122.888L151.756 131.303L126.383 133.863L122.451 123.022L157.213 122.888Z",
    fill: "url(#paint12_linear_14804_48825)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M115.587 129.219L122.951 123.505L126.976 134.016L115.587 129.219Z",
    fill: "url(#paint13_linear_14804_48825)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    filter: "url(#filter10_i_14804_48825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.716 109.598L101.771 120.595L114.888 129.84L122.261 123.757L101.716 109.598Z",
    fill: "#D48DD6",
    fillOpacity: 0.02
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M101.716 109.598L101.771 120.595L114.888 129.84L122.261 123.757L101.716 109.598Z",
    fill: "url(#paint14_linear_14804_48825)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M101.716 109.598L101.771 120.595L114.888 129.84L122.261 123.757L101.716 109.598Z",
    fill: "url(#paint15_linear_14804_48825)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M122.162 123.301L101.784 109.333L136.287 81.7L122.162 123.301Z",
    fill: "url(#paint16_linear_14804_48825)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M157.213 122.888L151.756 131.303L126.383 133.863L122.451 123.022L157.213 122.888Z",
    fill: "url(#paint17_linear_14804_48825)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_14804_48825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.4949 60.3216L94.7725 53.5377L96.4035 57.7415L88.3622 62.9309L76.4949 60.3216Z",
    fill: "#D48DD6",
    fillOpacity: 0.02
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4949 60.3216L94.7725 53.5377L96.4035 57.7415L88.3622 62.9309L76.4949 60.3216Z",
    fill: "url(#paint18_linear_14804_48825)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter13_i_14804_48825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.007 57.9502L113.618 48.9547L94.5853 53.6987L96.2236 58.0127L106.007 57.9502Z",
    fill: "#C56694",
    fillOpacity: 0.02
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M106.007 57.9502L113.618 48.9547L94.5853 53.6987L96.2236 58.0127L106.007 57.9502Z",
    fill: "url(#paint19_linear_14804_48825)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter14_i_14804_48825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.213 71.4635L89.6057 75.0933L76.4609 60.4679L88.2193 63.0477L93.213 71.4635Z",
    fill: "#C56694",
    fillOpacity: 0.02
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M93.213 71.4635L89.6057 75.0933L76.4609 60.4679L88.2193 63.0477L93.213 71.4635Z",
    fill: "url(#paint20_linear_14804_48825)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter15_i_14804_48825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.795 86.9001L101.58 75.6587L93.3004 71.125L89.7028 74.6971L104.795 86.9001Z",
    fill: "#5EFFFF",
    fillOpacity: 0.02
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M104.795 86.9001L101.58 75.6587L93.3004 71.125L89.7028 74.6971L104.795 86.9001Z",
    fill: "url(#paint21_linear_14804_48825)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter16_i_14804_48825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.25 67.5094L111.169 68.3837L105.285 87.014L101.857 75.8117L106.25 67.5094Z",
    fill: "#5EFFFF",
    fillOpacity: 0.02
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M106.25 67.5096L111.169 68.3837L105.285 87.014L101.856 75.8118L106.25 67.5096Z",
    fill: "url(#paint22_linear_14804_48825)"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter17_i_14804_48825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.093 57.5902L113.739 48.9829L111.228 68.1313L106.269 67.2443L106.093 57.5902Z",
    fill: "#5EFFFF",
    fillOpacity: 0.02
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M106.093 57.5902L113.741 48.9834L111.228 68.1313L106.27 67.2445L106.093 57.5902Z",
    fill: "url(#paint23_linear_14804_48825)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_i_14804_48825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.51 67.6598L98.7388 65.4935L102.166 75.9448L106.51 67.6598Z",
    fill: "#D48DD6",
    fillOpacity: 0.02
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_i_14804_48825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.102 57.5513L96.4242 57.6522L98.3981 65.4144L106.102 57.5513Z",
    fill: "#D48DD6",
    fillOpacity: 0.02
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_i_14804_48825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2711 63.0596L96.1116 57.9867L98.0845 65.3414L88.2711 63.0596Z",
    fill: "#D48DD6",
    fillOpacity: 0.02
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter21_i_14804_48825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.271 63.0597L98.4147 65.4182L101.843 75.8697L93.415 71.3316L88.271 63.0597Z",
    fill: "#D48DD6",
    fillOpacity: 0.02
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter22_i_14804_48825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.484 57.64L106.59 67.319L98.8176 65.1548L106.484 57.64Z",
    fill: "#D48DD6",
    fillOpacity: 0.02
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M88.3041 62.9172L93.2972 71.2641L101.548 75.8013L105.888 67.369L105.866 57.4963L96.2997 57.5905L88.3041 62.9172Z",
    fill: "url(#paint24_linear_14804_48825)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M88.3041 62.9172L93.2972 71.2641L101.548 75.8013L105.888 67.369L105.866 57.4963L96.2997 57.5905L88.3041 62.9172Z",
    fill: "url(#paint25_linear_14804_48825)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_14804_48825",
    x: 59.4688,
    y: 80.2369,
    width: 38.1335,
    height: 28.1781,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.88652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.552941 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14804_48825"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_14804_48825",
    x: 29.3318,
    y: 80.2371,
    width: 30.137,
    height: 34.0348,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.88652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.4 0 0 0 0 0.580392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14804_48825"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_14804_48825",
    x: 48.0708,
    y: 108.405,
    width: 31.959,
    height: 20.4498,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.88652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.552941 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14804_48825"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_14804_48825",
    x: 69.2966,
    y: 96.3772,
    width: 28.3511,
    height: 31.6036,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.88652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.552941 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14804_48825"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_14804_48825",
    x: 29.4683,
    y: 108.839,
    width: 35.5671,
    height: 19.9203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.88652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.4 0 0 0 0 0.580392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14804_48825"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_14804_48825",
    x: 122.365,
    y: 81.7712,
    width: 34.7495,
    height: 41.5824,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.3447
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14804_48825"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_14804_48825",
    x: 101.784,
    y: 81.7,
    width: 34.5029,
    height: 41.6012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.40781
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.552941 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14804_48825"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_14804_48825",
    x: 122.451,
    y: 122.888,
    width: 34.7625,
    height: 10.975,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.40781
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.4 0 0 0 0 0.580392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14804_48825"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_14804_48825",
    x: 101.716,
    y: 109.598,
    width: 20.5452,
    height: 20.2421,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.40781
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.552941 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14804_48825"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_14804_48825",
    x: 76.4949,
    y: 53.5377,
    width: 19.9087,
    height: 9.39319,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.19802
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.552941 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14804_48825"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_14804_48825",
    x: 94.5852,
    y: 48.9547,
    width: 19.0327,
    height: 9.05798,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.19802
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.4 0 0 0 0 0.580392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14804_48825"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_14804_48825",
    x: 76.4609,
    y: 60.4679,
    width: 16.7522,
    height: 14.6254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.19802
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.4 0 0 0 0 0.580392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14804_48825"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_i_14804_48825",
    x: 89.7029,
    y: 71.125,
    width: 15.0923,
    height: 15.775,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.19802
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.4 0 0 0 0 0.580392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14804_48825"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_i_14804_48825",
    x: 101.856,
    y: 67.5094,
    width: 9.31274,
    height: 19.5046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.19802
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.4 0 0 0 0 0.580392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14804_48825"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_i_14804_48825",
    x: 106.093,
    y: 48.9829,
    width: 7.64575,
    height: 19.1483,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.19802
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.4 0 0 0 0 0.580392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14804_48825"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_i_14804_48825",
    x: 98.7388,
    y: 65.4935,
    width: 7.77148,
    height: 10.4513,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.19802
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.552941 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14804_48825"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_i_14804_48825",
    x: 96.4243,
    y: 57.5513,
    width: 9.67773,
    height: 7.86316,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.19802
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.552941 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14804_48825"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_i_14804_48825",
    x: 88.271,
    y: 57.9867,
    width: 9.81348,
    height: 7.35474,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.2101
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.552941 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14804_48825"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_i_14804_48825",
    x: 88.271,
    y: 63.0597,
    width: 13.572,
    height: 12.8101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.19802
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.552941 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14804_48825"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_i_14804_48825",
    x: 98.8176,
    y: 57.64,
    width: 7.77197,
    height: 9.67896,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.19802
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.552941 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14804_48825"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14804_48825",
    x1: 59.7417,
    y1: 86.8311,
    x2: 82.6392,
    y2: 108.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF97FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14804_48825",
    x1: 81.9365,
    y1: 88.4927,
    x2: 78.8228,
    y2: 148.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EFFFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14804_48825",
    x1: 81.9365,
    y1: 88.4927,
    x2: 75.8378,
    y2: 147.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EFFFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14804_48825",
    x1: 86.8793,
    y1: 63.3398,
    x2: 39.1917,
    y2: 97.9742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF97FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF97FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14804_48825",
    x1: 27.667,
    y1: 86.05,
    x2: 42.9525,
    y2: 99.3531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF97FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF97FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14804_48825",
    x1: 64.0503,
    y1: 111.325,
    x2: 79.3848,
    y2: 136.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EFFFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14804_48825",
    x1: 74.1916,
    y1: 153.466,
    x2: 90.2151,
    y2: 111.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CFBD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CFBD5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14804_48825",
    x1: 111.078,
    y1: 122.225,
    x2: 88.6812,
    y2: 107.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CFBD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CFBD5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14804_48825",
    x1: 76.5432,
    y1: 146.403,
    x2: 46.4947,
    y2: 111.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CFBD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CFBD5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14804_48825",
    x1: 16.6435,
    y1: 152.641,
    x2: 42.4655,
    y2: 115.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CFBD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CFBD5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14804_48825",
    x1: 129.818,
    y1: 115.609,
    x2: 155.6,
    y2: 82.0234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF97FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_14804_48825",
    x1: 136.151,
    y1: 139.55,
    x2: 124.398,
    y2: 97.3017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF97FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF97FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_14804_48825",
    x1: 200.286,
    y1: 143.559,
    x2: 136.765,
    y2: 124.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_14804_48825",
    x1: 123.351,
    y1: 123.609,
    x2: 141.388,
    y2: 160.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_14804_48825",
    x1: 129.792,
    y1: 154.441,
    x2: 110.825,
    y2: 117.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF97FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF97FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_14804_48825",
    x1: 111.727,
    y1: 94.7368,
    x2: 102.718,
    y2: 122.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CFBD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CFBD5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_14804_48825",
    x1: 79.8764,
    y1: 76.6806,
    x2: 120.432,
    y2: 104.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CFBD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CFBD5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_14804_48825",
    x1: 99.299,
    y1: 164.469,
    x2: 144.68,
    y2: 120.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF97FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF97FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_14804_48825",
    x1: 70.2207,
    y1: 72.5202,
    x2: 86.4149,
    y2: 52.9431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_14804_48825",
    x1: 125.727,
    y1: 47.5382,
    x2: 102.065,
    y2: 59.0847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF97FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF97FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_14804_48825",
    x1: 54.4827,
    y1: 90.5397,
    x2: 89.4283,
    y2: 75.3842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_14804_48825",
    x1: 90.2603,
    y1: 62.6557,
    x2: 92.0924,
    y2: 82.1325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_14804_48825",
    x1: 130.847,
    y1: 86.0614,
    x2: 105.171,
    y2: 81.1745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_14804_48825",
    x1: 115.385,
    y1: 49.3657,
    x2: 149.474,
    y2: 98.4325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EFFFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_14804_48825",
    x1: 96.7796,
    y1: 61.138,
    x2: 95.0398,
    y2: 74.2813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EFFFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_14804_48825",
    x1: 96.7796,
    y1: 61.138,
    x2: 84.1854,
    y2: 55.2248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF97FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF97FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCognition);
export default __webpack_public_path__ + "static/media/Cognition.abe5d05c3d4d288e508effedc013ccb8.svg";
export { ForwardRef as ReactComponent };